import type { ContentLocale } from '@/data/public-catalog'

export const transportSystemProducts = {
  'prd-eugenio-esamed': {
    key: 'transportEugenio',
    primaryMedia: '/media/source/images/Eugenio-Esamed-1.png',
    supportingMedia: [
      '/media/source/images/EugenioAperto-scaled.jpg',
      '/media/source/images/Eugenio-1940-scaled.jpg',
      '/media/source/images/Eugenio-1974-scaled.jpg',
    ],
    sourceLocale: null,
  },
  'prd-piastre-refrigeranti-e-piastre-eutettiche-contenitore-terziari': {
    key: 'coolingPlates',
    primaryMedia: '/media/source/images/Accessori-terziari-esamed-1.png',
    supportingMedia: [
      '/media/source/images/Piastre-eutettiche-1.png',
      '/media/source/images/piastre-refrigeranti.png',
    ],
    sourceLocale: null,
  },
  'prd-esatrace': {
    key: 'esatrace',
    primaryMedia: '/media/source/logos/Logo-ESAtrace.png',
    supportingMedia: [
      '/media/source/images/DATALOGGER.png',
      '/media/source/images/1-Esatrace-check-out.jpg',
      '/media/source/images/2-Esatrace-check-in.jpg',
      '/media/source/images/3-Esatrace-esito.jpg',
      '/media/source/images/4-Esatrace-monitoraggio-missioni.jpg',
    ],
    sourceLocale: null,
  },
  'prd-contenitori-terziari-esamed-endmed': {
    key: 'tertiaryEndmed',
    primaryMedia: '/media/source/images/ES-BIO-M.png',
    supportingMedia: [],
    sourceLocale: null,
  },
  'prd-accessori-contenitore-secondario-bios': {
    key: 'biosAccessories',
    primaryMedia: '/media/source/images/Accessori-secondari-Esamed.png',
    supportingMedia: [
      '/media/source/images/ES-SP18.png',
      '/media/source/images/telini-1.png',
      '/media/source/images/ES-SP78.png',
      '/media/source/images/Rack-bianco-2.png',
      '/media/source/images/rack-rosso-3.png',
    ],
    sourceLocale: null,
  },
  'prd-contenitore-secondario-plasmapack': {
    key: 'plasmaPack',
    primaryMedia: '/media/source/images/plasmapack-esamed.png',
    supportingMedia: ['/media/source/images/plasmapack-tabella.png'],
    sourceLocale: null,
  },
  'prd-contenitore-secondario-busta-campioni-biologici': {
    key: 'bag',
    primaryMedia: '/media/source/images/Busta-biosicurezza.png',
    supportingMedia: ['/media/source/images/Busta.png'],
    sourceLocale: null,
  },
  'prd-contenitore-secondario-kartell-campioni-biologici': {
    key: 'kartell',
    primaryMedia: '/media/source/images/Contenitore-secondario-kartell-1.png',
    supportingMedia: ['/media/source/images/kartell.png'],
    sourceLocale: 'it',
  },
  'prd-contenitore-terziario-a-basso-spessore-samed': {
    key: 'slimline',
    primaryMedia: '/media/source/images/contenitori-terziari-a-basso-spessore-1.png',
    supportingMedia: [
      '/media/source/images/tabella-basso-spessore.png',
      '/media/source/images/ES-E-BIO-3.png',
      '/media/source/images/ES-E-EMO-2.png',
      '/media/source/images/ES-E-FAB-2.png',
    ],
    sourceLocale: null,
  },
  'prd-contenitori-terziari-esamed': {
    key: 'tertiary',
    primaryMedia: '/media/source/images/Contenitori-terziari-Esamed-1.png',
    supportingMedia: [
      '/media/source/images/trasporti.png',
      '/media/source/images/ES-BIO-2.png',
      '/media/source/images/ES-EMO-2.png',
      '/media/source/images/ES-FAB-2.png',
      '/media/source/images/ES-GEN-1.png',
    ],
    sourceLocale: 'it',
  },
  'prd-contenitore-secondario-bios-campioni-biologici': {
    key: 'biosContainers',
    primaryMedia: '/media/source/images/ES-BIOS-M.png',
    supportingMedia: [
      '/media/source/images/BIOS.png',
      '/media/source/images/ES-BIOS-L.png',
    ],
    sourceLocale: null,
  },
} as const

export type TransportSystemProductId = keyof typeof transportSystemProducts
export type TransportSystemProductKey = (typeof transportSystemProducts)[TransportSystemProductId]['key']

export function isTransportSystemProductId(id: string): id is TransportSystemProductId {
  return id in transportSystemProducts
}

export function transportSourceLocale(id: TransportSystemProductId, language: ContentLocale): ContentLocale {
  return transportSystemProducts[id].sourceLocale ?? language
}
